export default {
    downtimeUrl: "https://cl.kodland.tech",
    parameters: {
      landing_id: "LTMath",
      success_page: 'success_long',
    },
    startPage: {
      startBackground: "white",
      quizBackground: "#white",
      buttonFirst: true,
      title: 'Responde 3 preguntas y obtén una divertida lección de matemáticas ¡GRATIS!',
      subtitle: "En la lección: <br>• Se explicará cómo aprender matemáticas a través de un juego <br>• Se determinará tu nivel de conocimiento <br>• Se te mostrará cómo puedes mejorar tus habilidades matemáticas",
      image: {
        url:  "/welcome/quiz_latam_early_math_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_latam_early_math_mobile.png",
        style: {
          width: "100%",
        },
      },
       button: " Comenzar🚀 ",
    },
    successPage: {
      title: "¡Felicitaciones! 🎁",
      subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
    },
    quizRotateBySteps: {
      1: {
        question: "¿El niño tiene experiencia aprendiendo matemáticas, lógica o aritmética?",
        answers: [
            "Sí, estudió en la escuela",
            "Sí, estudió con los padres",
            "Sí, estudió en cursos o en el jardín de infancia",
            "No, no tiene experiencia",
         ],
      },
      2: {
        question: "¿Qué esperas de la primera lección gratuita?",
        answers: [
          "🔢 Descubrir el nivel actual de mi hijo",
          "🎯 Aprender a enfrentarse a desafíos",
          "📈 Aumentar la motivación de mi hijo",
          "🎲 Aprender a enseñarle matemáticas a mi hijo a través del juego"
        ],
      },
      3: {
        question:
          "¿Qué es lo más importante para ti en la educación de tu hijo?",
        answers: [
          "🤩 Actividades interactivas y divertidas",
          "🚀 Calidad de la educación",
          "💁🏼‍♂️ Enfoque individual",
          "💰 Relación calidad/precio",
          "👩🏽‍🏫 Profesor experto"
        ],
      },
      4: {
        question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
        answers: [
          "💻 Sí",
          {
            answer: "😐 No",
            stopAnswer: true
          },
        ],
      },
    },
  };
  
  
  